export enum TaskKind {
  KANBAN = "KANBAN",
  LEAD = "LEAD",
  CONTACT = "CONTACT",
  ORPHAN = "ORPHAN",
}
